module.exports = __webpack_public_path__ + "img/ic_reminder_blue.a8e2b9e1.svg";